<template>
    <div class="inner-container explanatory-note">
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
        <div class="section-title budget"><span>{{ $t("app.links.budgetPlanning") }}</span></div>
        <div>
            <b-progress
                variant="success"
                v-show="progress<100"
                height="10px"
                :value="progress"
                striped
                animated
            ></b-progress>
        </div>
        <div class="section-subtitle budget">
            <i class="icon icon-grid"></i>
            <span>{{ $t("app.links.budget_requests") }}<c-budg-form-lst
                :curFormSelect="'/exp-note'"/></span>
            <div class="actions-tab in-tab" id="bp-info-tab" style="top: 100px">

                <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none"
                            no-caret>
                    <template #button-content id="info-dropdown">
                        <div class="btn-download">
                            <div>
                                <span class="left">
                                    <i class="icon icon-info"></i>
                                </span>
                                <i class="icon icon-keyboard"></i>
                            </div>
                        </div>
                    </template>
                    <b-dropdown-text>
                        <div class="info-button">
                            <span style="text-transform: none" @click="downloadInstruction">{{
                                    $t("modules.bip.instruction")
                                }}<i class="icon icon-folder"></i></span>
                        </div>
                        <div class="info-text">
                            <p><span class="red bold"
                                     style="text-transform: none">{{ $t("modules.bip.mode") }}: {{
                                    $t("app.links.explanatory-note")
                                }}</span>
                            </p>
                            <p><span style="text-transform: none">{{
                                    $t("modules.bip.report.grade_3")
                                }}</span></p>
                        </div>
                    </b-dropdown-text>
                </b-dropdown>
                <b-dropdown v-if="moduleTabSwitch" variant="link" right
                            toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <div class="btn-download">
                            <div>
                                                    <span class="left">
                                                        <i class="icon icon-download"></i> {{
                                                            $t("modules.bip.btn.download")
                                                        }}
                                                    </span>
                                <i class="icon icon-keyboard"></i>
                            </div>
                        </div>
                    </template>
                    <b-dropdown-item id="report-first" @click="reportGu()">
                        {{
                            isGkkp
                                ? $t("modules.explanatory_note.pz_gkkp")
                                : $t("modules.explanatory_note.pz_gu")
                        }}
                    </b-dropdown-item>
                    <b-dropdown-item id="report-first" @click="reportAbp()">{{
                            $t("modules.explanatory_note.pz_abp")
                        }}
                    </b-dropdown-item>
                </b-dropdown>

            </div>
        </div>
        <div v-if="moduleTabSwitch" class="filter-area">
            <div class="filter-container">
                <div class="left-content">
                    <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                        <template #button-content>
                            <span class="lc"><i class="icon icon-filter"></i> {{
                                    $t("modules.bip.filter.title")
                                }}</span><span
                            class="rc"><i class="icon icon-keyboard"></i></span>
                        </template>
                        <div>
                            <div class="top-content">
                                <span> {{
                                        $t("modules.bip.filter.filter_params.title")
                                    }}</span>
                                <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                            </div>
                            <div class="filter-block">
                                <b-form-group
                                    :label="$t('modules.bip.filter.filter_params.choose_organization')">
                                    <b-form-radio-group
                                        v-model="selectedOrganization"
                                        :options="organizationOptionsSelect"
                                        name="organizationOptions"
                                        @change="onOrganizationChange">
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>

                            <!--------------- Плановый период ------------------->
                            <div class="filter-block">
                                <b-form-group
                                    :label="$t('modules.bip.filter.filter_params.plan_period')">
                                    <multiselect
                                        :disabled="false"
                                        v-model="curYear"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выбрать год"
                                        :options="yearPeriodsFilter"
                                        :searchable="false"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="onYearPeriodsFilterChange"
                                        ref="yearPeriodRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <div class="filter-block">
                                <b-form-group
                                    :label="$t('modules.bip.filter.filter_params.region')">
                                    <multiselect
                                        v-model="curRegion"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выбрать регион"
                                        :options="regionFilter"
                                        :searchable="false"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="onRegionFilterChange"
                                        ref="regRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!----------------Вид данных------------------->
                            <div class="filter-block">
                                <b-form-group
                                    :label="$t('modules.bip.filter.filter_params.data_type')">
                                    <multiselect
                                        v-model="curBudgetType"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выбрать вид данных"
                                        :options="budgetTypeFilter"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="onBudgetTypeFilterChange"
                                        ref="dataTypeRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!----------------Версия бюджета------------------->
                            <div class="filter-block">
                                <b-form-group
                                    :label="$t('modules.bip.filter.filter_params.version')">
                                    <multiselect
                                        v-model="curBudgetVariant"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выбрать версию бюджета"
                                        :options="budgetVariantFilter"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="onBudgetVariantFilterChange"
                                        ref="versionRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!----------------Администратор программ abp------------------->
                            <div class="filter-block">
                                <b-form-group :label="$t('modules.bip.card.sector_1.adm_programs')">
                                    <multiselect
                                        v-model="curAbp"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выбрать адм. программ"
                                        :options="abpFilter"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="onAbpFilterChange"
                                        ref="abpRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!----------------Гос.учреждение------------------->
                            <div class="filter-block">
                                <b-form-group
                                    :label="$t('modules.bip.card.sector_1.st_establishment')"
                                    :disabled="isGkkp">
                                    <multiselect
                                        v-model="curGu"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выбрать гос. учреждение"
                                        :options="guFilter"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="onGuFilterChange"
                                        ref="guRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!----------------ГККП------------------->
                            <div class="filter-block" v-if="isGkkp">
                                <b-form-group :label="$t('modules.budget_request.filter.gkkp')">
                                    <multiselect
                                        v-model="curGkkp"
                                        track-by="name"
                                        label="name"
                                        placeholder="Выбрать ГККП"
                                        :options="gkkpFilter"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="onGkkpFilterChange"
                                        ref="gkkpRef"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>

                            <div class="filter-block">
                                <b-button variant="success" @click="chgParams"
                                          :disabled="isDisabled">
                                    {{ $t('modules.budget_request.filter.open') }}
                                </b-button>
                            </div>
                        </div>
                    </b-dropdown>
                </div>
            </div>
            <c-breadcrumbs :curYear="curYear" :curRegion="curRegion"
                           :curBudgetType="curBudgetType" :curBudgetVariant="curBudgetVariant"
                           :curAbp="curAbp" :curGu="curGu" :isGkkp="isGkkp" :curGkkp="curGkkp"
                           @openFilterByRef="openFilterByRef"></c-breadcrumbs>
            <div class="table-container">
                <div class="b-table-sticky-header table-responsive-true">
                    <table class="table b-table table-bordered b-table-no-border-collapse">
                        <thead>
                        <tr class="text-center">
                            <th rowspan="2" class="toggle-show">
                                <button type="button" class="btn btn-secondary"
                                        @click="collapse = !collapse;">
                                    <i class="icon icon-chevron-circle" v-if="collapse"></i>
                                    <i class="icon icon-chevron-circle icon-rotate-180" v-else></i>
                                </button>
                            </th>
                            <th style="width: 0;">
                                {{ $t('modules.budget_execution_alteration.function_group') }}
                            </th>
                            <th>{{ $t('modules.budget_execution_alteration.abp') }}</th>
                            <th v-if="!isGkkp">{{ $t('modules.budget_request.filter.gu') }}</th>
                            <th v-if="isGkkp">{{ $t('modules.budget_request.filter.gkkp') }}</th>
                            <th>{{ $t('modules.budget_request.filter.prg') }}</th>
                            <th>{{
                                    $t('modules.budget_request.calculation_forms.table_headers.common.name')
                                }}
                            </th>
                            <th>{{ $t('modules.explanatory_note.status_a') }}</th>
                            <th>{{ $t('modules.explanatory_note.status_b') }}</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>


                        <template v-for="(funcGr, funcGrIndex) in treeData">
                            <tr :key="`funcGrIndex_${funcGrIndex}`" class="table-info">
                                <td class="toggle-show">
                                    <button type="button" class="btn btn-secondary"
                                            @click="collapseItems(funcGrIndex)">
                                        <i class="icon icon-chevron-circle"
                                           v-if="collapseArr[funcGrIndex]"></i>
                                        <i class="icon icon-chevron-circle icon-rotate-180"
                                           v-else></i>
                                    </button>
                                </td>
                                <td colspan="8">{{ funcGr.gr }}-{{ getLocalizedName(funcGr) }}</td>
                            </tr>

                            <template v-if="!collapseArr[funcGrIndex]">
                                <template v-for="(abp, abpIndex) in funcGr.children">

                                    <tr :key="`abpIndex_${abpIndex}_${funcGrIndex}`"
                                        class="table-info" style="background-color: #ecf7ff">
                                        <td></td>
                                        <td class="toggle-show">
                                            <button type="button" class="btn btn-secondary"
                                                    @click="collapseItemsSec(abpIndex)">
                                                <i class="icon icon-chevron-circle"
                                                   v-if="collapseArrSec[abpIndex]"></i>
                                                <i class="icon icon-chevron-circle icon-rotate-180"
                                                   v-else></i>
                                            </button>
                                        </td>
                                        <td colspan="7">{{ abp.abp }}-{{
                                                getLocalizedName(abp)
                                            }}
                                        </td>
                                    </tr>

                                    <template v-if="!collapseArrSec[abpIndex]">
                                        <template
                                            v-for="(guGkkp, guGkkpIndex) in abp.children">
                                            <tr :key="`guGkkpIndex_${guGkkpIndex}_${abpIndex}_${funcGrIndex}`"
                                                style="background-color: rgb(236, 247, 255);">
                                                <td colspan="2"></td>
                                                <td class="toggle-show">
                                                    <button type="button"
                                                            class="btn btn-secondary"
                                                            @click="collapseItemsThird(guGkkpIndex)">
                                                        <i class="icon icon-chevron-circle"
                                                           v-if="collapseArrThird[guGkkpIndex]"></i>
                                                        <i class="icon icon-chevron-circle icon-rotate-180"
                                                           v-else></i>
                                                    </button>
                                                </td>
                                                <td colspan="6">{{
                                                        guGkkp.code
                                                    }}-{{ getLocalizedName(guGkkp) }}
                                                </td>
                                            </tr>

                                            <template v-if="!collapseArrThird[guGkkpIndex]">
                                                <template
                                                    v-for="(item, itemIndex) in guGkkp.children">
                                                    <tr :key="`elementItemIndex_${guGkkpIndex}_${abpIndex}_${funcGrIndex}_${itemIndex}`">
                                                        <td colspan="4"></td>
                                                        <td>{{ item.prg }}</td>
                                                        <td>{{ getLocalizedName(item) }}</td>
                                                        <td>
                                                            {{ getLocalizedName(item.agrName) }}
                                                        </td>
                                                        <td>{{ item.updateDate }}</td>
                                                        <td style="text-align: center">
                                                            <b-dropdown
                                                                id="dropdown-dropleft"
                                                                dropleft class="more">
                                                                <template v-slot:button-content>
                                                                    <i class="icon icon-more"></i>
                                                                </template>
                                                                <template>
                                                                    <template
                                                                        v-if="item.editable===true">
                                                                        <b-dropdown-item
                                                                            @click="editBtn(item, true)">
                                                                            {{
                                                                                $t('modules.app.additional_npa.tools.edit')
                                                                            }}
                                                                        </b-dropdown-item>
                                                                        <b-dropdown-item
                                                                            @click="deleteBtn(item)">
                                                                            {{
                                                                                $t('modules.app.additional_npa.tools.delete')
                                                                            }}
                                                                        </b-dropdown-item>
                                                                    </template>
                                                                    <template v-else>
                                                                        <b-dropdown-item
                                                                            @click="editBtn(item, false)">
                                                                            {{
                                                                                $t('modules.explanatory_note.preview')
                                                                            }}
                                                                        </b-dropdown-item>
                                                                    </template>
                                                                </template>
                                                            </b-dropdown>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <c-explanatoryNoteTabs :curYear="curYear" :curAbp="curAbp" :curGu="curGu"
                               :curRegion="curRegion" :curBudgetType="curBudgetType"
                               :curBudgetVariant="curBudgetVariant" :openAddTab="openAddTab"
                               :curPrg="curPrg" :editable="editable" :userId="userId"
                               :isGkkp="isGkkp"
                               :curGkkp="curGkkp"
                               @moduleTabSwitches="moduleTabSwitches" v-if="openAddTab"/>
    </div>

</template>
<script>

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Multiselect from 'vue-multiselect';
import CBudgetFormsList from "@/modules/budget-request/components/budget-forms-list";
import CBreadCrumbs from './components/table-dri-breadcrumbs.vue';
import ExplanatoryNoteTabs from './components/ExplanatoryNoteTabs'
import {parseInt} from "lodash";
import VueElementLoading from 'vue-element-loading';
import {makeToast} from "@/modules/budget/bip/bip-types";
import axios from "axios";


export default {
    name: "initialFormOfNote",
    components: {
        'c-budg-form-lst': CBudgetFormsList,
        'c-breadcrumbs': CBreadCrumbs,
        'c-explanatoryNoteTabs': ExplanatoryNoteTabs,
        'multiselect': Multiselect,
        'loading': VueElementLoading
    },
    created() {
        this.$watch('collapseAll', this.collapseAllFunc);
    },
    computed: {

        organizationOptionsSelect() {
            const langMap = {ru: 'nameRu', kk: 'nameKk', en: 'nameEn'};
            const langKey = langMap[this.$i18n.locale] || 'nameRu';
            return this.organizationOptions.map(opt => ({
                text: opt[langKey],
                value: opt.value,
                disabled: opt.disabled,
            }));
        }
    },

    async mounted() {
        this.userId = this.$store.getters.user_uuid;
        await this.setOrganizationOptions();
        await this.setYearPeriodsFilterAndCurYear();
        await this.setRegions()
        await this.setBudgetTypes()
        await this.setBudgetVariants()
        await this.setAbpList()
        await this.setGuGkkpList()
        this.chgParams();
        this.editAccess = await this.getRole();
    },

    data() {
        return {
            userId: null,
            organizationOptions: [
                {nameRu: 'ГУ', nameEn: 'SOE', nameKk: 'ММ', value: 'GU', disabled: false},
                {nameRu: 'ГККП', nameEn: 'SCPSE', nameKk: 'МКҚК', value: 'GKKP', disabled: false}
            ],
            selectedOrganization: 'GU', // По умолчанию выбран ГУ
            isGkkp: false,
            yearPeriodsFilter: [],
            curYear: {},
            regionFilter: [],
            curRegion: null,
            budgetTypeFilter: [],
            curBudgetType: null,
            budgetVariantFilter: [],
            curBudgetVariant: null,
            abpFilter: [],
            curAbp: null,
            guFilter: [],
            curGu: null,
            gkkpFilter: [],
            curGkkp: null,
            treeData: [],
            isDisabled: true,
            collapse: true,
            collapseArr: [],
            collapseArrSec: [],
            collapseArrThird: [],
            loading: false,
            moduleTabSwitch: true,
            openAddTab: false,
            editable: false,
            curPrg: {},
            editAccess: false,
            programList: [],
            progress: 0
        }
    },

    methods: {

        async getRole() {
            const accessLevel = await this.getUserAccess(this.userId);

            if (accessLevel === 1) {
                return false;
            } else if (accessLevel === 2 || accessLevel === 3) {
                return true;
            }
            return false;
        },

        async getUserAccess(userId) {
            let accessLevel = 1;
            const modules = '004.002.009';
            const url = '/api-py/user-modules/' + userId;
            const response = await fetch(url);
            const items = await response.json();
            const access = getAccess(items, modules);
            accessLevel = access.access_level

            function getAccess(items, modules) {
                const res = {};
                if (items.length > 0) {
                    for (const item of items) {
                        if (item.modules === modules) {
                            return item;
                        }
                    }
                }
                return res;
            }

            return accessLevel;
        },

        async setOrganizationOptions() {
            const userSettings = await this.getOrganizationOptions();

            const baseOrganizations = [
                {nameRu: 'ГУ', nameEn: 'SOE', nameKk: 'ММ', value: 'GU'},
                {nameRu: 'ГККП', nameEn: 'SCPSE', nameKk: 'МКҚК', value: 'GKKP'}
            ];

            // Клонируем и дополняем
            this.organizationOptions = baseOrganizations.map(org => {
                let disabled = true;
                if (org.value === 'GU' && userSettings.onlyGU) disabled = false;
                if (org.value === 'GKKP' && userSettings.onlyGKKP) disabled = false;
                return {...org, disabled};
            });

            if (userSettings.onlyGKKP && !userSettings.onlyGU) {
                this.selectedOrganization = 'GKKP';
                this.isGkkp = true;
            } else {
                this.selectedOrganization = 'GU';
                this.isGkkp = false;
            }
        },

        async getOrganizationOptions() {
            try {
                // Получаем данные для ГУ
                const urlGu = '/api-py/user-gu/' + this.userId;
                const guArr = await fetch(urlGu).then(response => response.json());

                // Получаем данные для ГККП
                const urlGkkp = '/api-py/user-kgkp/' + this.userId;
                const gkkpArr = await fetch(urlGkkp).then(response => response.json());

                // Проверяем условия
                if (guArr.length > 0 && gkkpArr.length === 0) {
                    // Если только ГУ
                    return {onlyGU: true, onlyGKKP: false};
                } else if (guArr.length === 0 && gkkpArr.length > 0) {
                    // Если только ГККП
                    return {onlyGU: false, onlyGKKP: true};
                } else {
                    // Если доступны и ГУ, и ГККП
                    return {onlyGU: true, onlyGKKP: true};
                }
            } catch (error) {
                this.makeToast('Ошибка получения настроек пользователя:', error);
                return {onlyGU: false, onlyGKKP: false}; // Возвращаем значение по умолчанию в случае ошибки
            }
        },

        async onOrganizationChange(value) {
            this.isGkkp = value === 'GKKP';
            await this.setYearPeriodsFilterAndCurYear();
            await this.setRegions()
            await this.setBudgetTypes()
            await this.setBudgetVariants()
            await this.setAbpList()
            await this.setGuGkkpList()
        },

        setYearPeriodsFilterAndCurYear() {
            const curYear = new Date().getFullYear();
            const periodLst = [];
            const startDate = 2021; //так как разработка е-Акимат началась с 2021 года
            const nextYear = curYear + 1;
            const endDate = nextYear + 2;
            for (let year = endDate; year >= startDate; year--) {
                periodLst.push({
                    name: `${year} - ${year + 2}`,
                    year: year,
                    periods: [year, year + 1, year + 2]
                });
                if (nextYear === year) {
                    this.curYear = {
                        name: `${year} - ${year + 2}`,
                        year: year,
                        periods: [year, year + 1, year + 2]
                    };
                }
            }
            this.yearPeriodsFilter = periodLst;
        },

        async onYearPeriodsFilterChange(value) {
            this.curYear = value;
            await this.setRegions()
            await this.setBudgetTypes()
            await this.setBudgetVariants()
            await this.setAbpList()
            await this.setGuGkkpList()
        },


        async setRegions() {
            const resultArr = await this.getRegions();
            if (resultArr.length === 0) {
                this.regionFilter = []
                this.curRegion = null
                this.budgetTypeFilter = []
                this.curBudgetType = null
                this.budgetVariantFilter = []
                this.curBudgetVariant = null
                this.abpFilter = []
                this.curAbp = null
                this.guFilter = []
                this.curGu = null
                this.gkkpFilter = []
                this.curGkkp = null
                return
            }
            this.curRegion = {
                region: resultArr[0].region.code,
                nameRu: resultArr[0].region.nameRu,
                nameKk: resultArr[0].region.nameKk,
                nameEn: resultArr[0].region.nameEn,
                name: this.setNameByLocale(resultArr[0].region, resultArr[0].region.code)
            };
            this.regionFilter = []
            this.regionFilter = resultArr.map(item => {
                const nameLocale = this.setNameByLocale(item.region, item.region.code)
                return {
                    region: item.region.code,
                    nameRu: item.region.nameRu,
                    nameKk: item.region.nameKk,
                    nameEn: item.region.nameEn,
                    name: nameLocale
                }
            });
        },

        async getRegions() {
            this.loading = true;
            try {

                const queryParams = new URLSearchParams({
                    cur_year: this.curYear.year,
                    user_id: this.userId,
                    is_gkkp: this.isGkkp,
                });

                const url = `/api/explanatory-note/filter/region?${queryParams.toString()}`;
                const result = await fetch(url).then(response => response.json());
                if (result) {
                    this.loading = false;
                    return result;
                }
            } catch (error) {
                this.makeToast('Ошибка загрузки данных', 'По данному запросу ничего не найдено');
                this.loading = false;
                return null;
            }
        },

        async onRegionFilterChange(value) {
            this.curRegion = value;
            await this.setBudgetTypes()
            await this.setBudgetVariants()
            await this.setAbpList()
            await this.setGuGkkpList()
        },

        async setBudgetTypes() {
            const resultArr = await this.getBudgetTypes();
            if (resultArr.length === 0) {
                this.budgetTypeFilter = []
                this.curBudgetType = null
                this.budgetVariantFilter = []
                this.curBudgetVariant = null
                this.abpFilter = []
                this.curAbp = null
                this.guFilter = []
                this.curGu = null
                this.gkkpFilter = []
                this.curGkkp = null
                return
            }
            this.curBudgetType = {
                budget: resultArr[0].budgetType.code,
                nameRu: resultArr[0].budgetType.nameRu,
                nameKk: resultArr[0].budgetType.nameKk,
                nameEn: resultArr[0].budgetType.nameEn,
                name: this.setNameByLocale(resultArr[0].budgetType, resultArr[0].budgetType.code)

            };
            this.budgetTypeFilter = []
            this.budgetTypeFilter = resultArr
                .sort((a, b) => a.budgetType.code.localeCompare(b.budgetType.code)) // Сортировка по code
                .map(item => {
                    const nameLocale = this.setNameByLocale(item.budgetType, item.budgetType.code);
                    return {
                        budget: item.budgetType.code,
                        nameRu: item.budgetType.nameRu,
                        nameKk: item.budgetType.nameKk,
                        nameEn: item.budgetType.nameEn,
                        name: nameLocale,
                    }
                });
        },

        async getBudgetTypes() {
            this.loading = true;
            try {
                const queryParams = new URLSearchParams({
                    cur_year: this.curYear.year,
                    user_id: this.userId,
                    is_gkkp: this.isGkkp,
                    region: this.curRegion.region,
                });

                const url = `/api/explanatory-note/filter/budget-type?${queryParams.toString()}`;
                const result = await fetch(url).then(response => response.json());
                if (result) {
                    this.loading = false;
                    return result;
                }
            } catch (error) {
                this.makeToast('Ошибка загрузки данных', 'По данному запросу ничего не найдено');
                this.loading = false;
                return null;
            }
        },

        async onBudgetTypeFilterChange(value) {
            this.curBudgetType = value;
            await this.setBudgetVariants()
            await this.setAbpList()
            await this.setGuGkkpList()
        },

        async setBudgetVariants() {
            const resultArr = await this.getBudgetVariants();
            if (resultArr.length === 0) {
                this.budgetVariantFilter = []
                this.curBudgetVariant = null
                this.abpFilter = []
                this.curAbp = null
                this.guFilter = []
                this.curGu = null
                this.gkkpFilter = []
                this.curGkkp = null
                return
            }

            this.curBudgetVariant = {
                variant: resultArr[0].budgetVariant.code,
                nameRu: resultArr[0].budgetVariant.nameRu,
                nameKk: resultArr[0].budgetVariant.nameKk,
                nameEn: resultArr[0].budgetVariant.nameEn,
                attribute: resultArr[0].budgetVariant.attribute,
                status: resultArr[0].budgetVariant.status,
                name: this.variantNameLangSupport(resultArr[0].budgetVariant)

            };

            this.budgetVariantFilter = [];
            this.budgetVariantFilter = resultArr.map(item => {
                return {
                    variant: item.budgetVariant.code,
                    nameRu: item.budgetVariant.nameRu,
                    nameKk: item.budgetVariant.nameKk,
                    nameEn: item.budgetVariant.nameEn,
                    attribute: item.budgetVariant.attribute,
                    status: item.budgetVariant.status,
                    name: this.variantNameLangSupport(item.budgetVariant),

                };
            });
        },

        async getBudgetVariants() {
            this.loading = true;
            try {
                const queryParams = new URLSearchParams({
                    cur_year: this.curYear.year,
                    user_id: this.userId,
                    is_gkkp: this.isGkkp,
                    region: this.curRegion.region,
                    budget_type: this.curBudgetType.budget,

                });

                const url =
                    `/api/explanatory-note/filter/budget-variant?${queryParams.toString()}`;
                const result = await fetch(url).then(response => response.json());
                if (result) {
                    this.loading = false;
                    return result;
                }
            } catch (error) {
                this.makeToast('Ошибка загрузки данных', 'По данному запросу ничего не найдено');
                this.loading = false;
                return null;
            }
        },

        async onBudgetVariantFilterChange(value) {
            this.curBudgetVariant = value;
            await this.setAbpList()
            await this.setGuGkkpList()
        },

        async setAbpList() {
            const resultArr = await this.getAbpList();
            if (resultArr.length === 0) {
                this.abpFilter = []
                this.curAbp = null
                this.guFilter = []
                this.curGu = null
                this.gkkpFilter = []
                this.curGkkp = null
                return
            }

            this.curAbp = {
                abp: resultArr[0].abp.code,
                nameRu: resultArr[0].abp.nameRu,
                nameKk: resultArr[0].abp.nameKk,
                nameEn: resultArr[0].abp.nameEn,
                name: this.setNameByLocale(resultArr[0].abp, resultArr[0].abp.code),
            };

            this.abpFilter = []
            this.abpFilter = resultArr.map(item => {
                const nameLocale = this.setNameByLocale(item.abp, item.abp.code);
                return {
                    abp: item.abp.code,
                    nameRu: item.abp.nameRu,
                    nameKk: item.abp.nameKk,
                    nameEn: item.abp.nameEn,
                    name: nameLocale,
                }

            });
        },


        async getAbpList() {
            this.loading = true;
            try {
                const queryParams = new URLSearchParams({
                    cur_year: this.curYear.year,
                    user_id: this.userId,
                    is_gkkp: this.isGkkp,
                    region: this.curRegion.region,
                    budget_type: this.curBudgetType.budget,
                    budget_variant: this.curBudgetVariant.variant,
                });

                const url = `/api/explanatory-note/filter/abp?${queryParams.toString()}`;
                const result = await fetch(url).then(response => response.json());
                if (result) {
                    this.loading = false;
                    return result;
                }
            } catch (error) {
                this.makeToast('Ошибка загрузки данных', 'По данному запросу ничего не найдено');
                this.loading = false;
                return null;
            }
        },

        async onAbpFilterChange(value) {
            this.curAbp = value;
            await this.setGuGkkpList()
        },

        async setGuGkkpList() {
            const resultArr = await this.getGuGkkpList();

            if (resultArr.length === 0) {
                this.guFilter = []
                this.curGu = null
                this.gkkpFilter = []
                this.curGkkp = null
                return
            }

            this.curGu = {
                gu: resultArr[0].gu.code,
                nameRu: resultArr[0].gu.nameRu,
                nameKk: resultArr[0].gu.nameKk,
                nameEn: resultArr[0].gu.nameEn,
                name: this.setNameByLocale(resultArr[0].gu, resultArr[0].gu.code),
            }

            this.guFilter = []
            this.guFilter = resultArr.map(item => {
                const nameLocale = this.setNameByLocale(item.gu, item.gu.code);
                return {
                    gu: item.gu.code,
                    nameRu: item.gu.nameRu,
                    nameKk: item.gu.nameKk,
                    nameEn: item.gu.nameEn,
                    name: nameLocale,
                }
            });


            if (this.isGkkp) {
                this.curGkkp = {
                    gkkp: resultArr[0].gkkp.code,
                    nameRu: resultArr[0].gkkp.nameRu,
                    nameKk: resultArr[0].gkkp.nameKk,
                    nameEn: resultArr[0].gkkp.nameEn,
                    name: this.setNameByLocale(resultArr[0].gkkp, resultArr[0].gkkp.code),
                    gu: this.curGu
                }
                this.gkkpFilter = []
                this.gkkpFilter = resultArr.map(item => {
                    return {
                        gkkp: item.gkkp.code,
                        nameRu: item.gkkp.nameRu,
                        nameKk: item.gkkp.nameKk,
                        nameEn: item.gkkp.nameEn,
                        name: this.setNameByLocale(item.gkkp, item.gkkp.code),
                        gu: {
                            gu: item.gu.code,
                            nameRu: item.gu.nameRu,
                            nameKk: item.gu.nameKk,
                            nameEn: item.gu.nameEn,
                            name: this.setNameByLocale(item.gu, item.gu.code),
                        }
                    }
                });
            }
        },

        async getGuGkkpList() {
            this.loading = true;
            try {
                const queryParams = new URLSearchParams({
                    cur_year: this.curYear.year,
                    user_id: this.userId,
                    region: this.curRegion.region,
                    budget_type: this.curBudgetType.budget,
                    budget_variant: this.curBudgetVariant.variant,
                    abp: this.curAbp.abp,
                    is_gkkp: this.isGkkp,
                });

                const url = `/api/explanatory-note/filter/gu-gkkp?${queryParams.toString()}`;
                const result = await fetch(url).then(response => response.json());
                if (result) {
                    this.loading = false;
                    this.isDisabled = false;
                    return result;
                }
            } catch (error) {
                this.makeToast('Ошибка загрузки данных', 'По данному запросу ничего не найдено');
                this.loading = false;
                return null;
            }
        },


        onGuFilterChange(value) {
            this.curGu = value;
        },
        onGkkpFilterChange(value) {
            this.curGu = value.gu;
            this.curGkkp = value;
        },

        setNameByLocale(obj, codeName) {
            if (obj === null) {
                return null;
            }
            return `${codeName} - ${this.getLocalizedName(obj)}`;
        },

        getLocalizedName(item) {
            const locale = this.$i18n.locale
            if (!item) return '';
            switch (locale) {
                case 'kk':
                    return item.nameKk || item.nameRu
                case 'en':
                    return item.nameEn || item.nameRu
                default:
                    return item.nameRu
            }
        },

        variantNameLangSupport(obj) {
            const langCode = this.$i18n.locale;
            let res = this.getLocalizedName(obj);
            if (obj.status === true) {
                switch (langCode) {
                    case 'kk':
                        res = res + ' (бекiт)';
                        break;
                    case 'en':
                        res = res + ' (appr)';
                        break;
                    default:
                        res = res + ' (утв)';
                        break;
                }
            }
            if (obj.attribute === true) {
                switch (langCode) {
                    case 'kk':
                        res = res + ' (өзек)';
                        break;
                    case 'en':
                        res = res + ' (act)';
                        break;
                    default:
                        res = res + ' (акт)';
                        break;
                }
            }
            return res;
        },

        chgParams() {
            this.loadBudgetRequestFormTotal();
            this.collapse = true;
            if (this.collapseArr.length > 0) {
                for (let i = 0; i < this.collapseArr; i++) {
                    this.collapseArr[i] = this.collapse;
                }
            }
        },

        async loadBudgetRequestFormTotal() {
            this.loading = true;
            this.treeData = [];
            this.programList = [];

            try {

                const params = new URLSearchParams({
                    cur_year: this.curYear.year,
                    user_id: this.userId,
                    region: this.curRegion.region,
                    budget_type: this.curBudgetType.budget,
                    budget_variant: this.curBudgetVariant.variant,
                    abp: this.curAbp.abp,
                    gu: this.curGu.gu,
                    is_gkkp: this.isGkkp,
                    gkkp: this.curGkkp?.gkkp,
                });

                const url = `/api/explanatory-note/total?${params.toString()}`;
                const result = await fetch(url).then(response => response.json());

                const localTree = [];
                for (const funGr of result) {
                    const funGrNode = {
                        gr: funGr.gr,
                        nameRu: funGr.nameRu,
                        nameKk: funGr.nameKk,
                        nameEn: "",
                        name: this.setNameByLocale(funGr, funGr.gr),
                        children: [] // Узлы `abp`
                    };

                    for (const abp of funGr.child) {
                        const abpNode = {
                            abp: abp.abp,
                            nameRu: abp.nameRu,
                            nameKk: abp.nameKk,
                            nameEn: "",
                            name: this.setNameByLocale(abp, abp.abp),
                            children: [] // Узлы `gu`
                        };

                        for (const gu of abp.child) {
                            const guNode = {
                                code: gu.guOrGkkp,
                                nameRu: gu.nameRu,
                                nameKk: gu.nameKk,
                                nameEn: "",
                                name: this.setNameByLocale(gu, gu.guOrGkkp),
                                children: [] // Узлы `prg`
                            };

                            for (const prg of gu.child) {
                                const prgNode = {
                                    gr: funGr.gr,
                                    abp: abp.abp,
                                    prg: prg.prg,
                                    name: this.setNameByLocale(prg, prg.prg),
                                    nameRu: prg.nameRu,
                                    nameKk: prg.nameKk,
                                    agrNameEn: prg.formTotalAgreement.nameEn,
                                    agrNameKk: prg.formTotalAgreement.nameKk,
                                    agrNameRu: prg.formTotalAgreement.nameRu,
                                    agrName: {
                                        nameRu: prg.formTotalAgreement.nameRu,
                                        nameKk: prg.formTotalAgreement.nameKk,
                                        nameEn: prg.formTotalAgreement.nameEn,
                                    },
                                    editable: prg.editStatus,
                                    pprItems: prg.pprItems,
                                    pprSet: prg.pprSet,
                                    updateDate: prg.dateOfRequestNoteUpdate
                                        ? new Date(prg.dateOfRequestNoteUpdate).toLocaleString().split(",")[0]
                                        : ""
                                };

                                guNode.children.push(prgNode); // Добавляем узел `prg` к `gu`
                                this.programList.push({
                                    prg: prg.prg,
                                    nameRu: prg.nameRu,
                                    nameKk: prg.nameKk,
                                })
                            }

                            abpNode.children.push(guNode); // Добавляем узел `gu` к `abp`
                        }

                        funGrNode.children.push(abpNode); // Добавляем узел `abp` к `funGr`
                    }

                    localTree.push(funGrNode); // Добавляем корневой узел `funGr` в дерево
                }
                this.treeData = localTree
                console.log("tree-----------------------------------------")
                console.log(localTree)
                this.loading = false;

            } catch (error) {
                this.loading = false;
                this.makeToast('Статус поиска', 'По данному запросу ничего не найдено');
            }
        },

        editBtn(item, editStatus) {
            if (item) {
                this.openAddTab = true;
                this.moduleTabSwitch = false;
                this.curPrg = item;
                this.editable = editStatus;
            }
        },

        moduleTabSwitches(item) {
            if (item) {
                this.openAddTab = !item;
                this.moduleTabSwitch = item;
            }
        },

        async deleteBtn(item) {
            this.$bvModal.msgBoxConfirm(
                'Вы действительно хотите удалить данные?',
                {
                    title: 'Подтверждение',
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Да',
                    cancelTitle: 'Нет',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    if (value) {
                        const curYear = this.curYear.year;
                        const curRegion = this.curRegion.region;
                        const gu = this.curGu.gu;
                        const gkkp = this.curGkkp?.gkkp;
                        const budgetTypeId = this.curBudgetType.budget;
                        const budgetVariantId = this.curBudgetVariant.variant;
                        const params = {
                            'id': parseInt(item.id),
                            'gr': parseInt(item.gr),
                            'abp': parseInt(item.abp),
                            'prg': parseInt(item.prg),
                            'curYear': parseInt(curYear),
                            'curRegion': curRegion,
                            'gu': gu,
                            'gkkp': gkkp,
                            'budgetTypeId': budgetTypeId,
                            'budgetVariantId': budgetVariantId,
                            'userId': this.userId
                        };
                        try {
                            const url = '/api/explanatory-note/remove';
                            const response = await fetch(url, {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(params) // массив будет направлен на kotlin
                            });
                            const result = await response.json();
                            if ((response.status === 200) && (result === true)) {
                                this.makeToast('Очистка заявки', 'Данные успешно удалены');
                                await this.loadBudgetRequestFormTotal();
                            }
                        } catch {
                            this.makeToast('Очистка заявки', 'Ошибка удаления заявки');
                        }
                    }
                })
                .catch(error => {
                    this.makeToast('danger', 'Ошибка удаления', error.toString());
                    this.loading = false;
                });
        },

        async getNote(note) {
            try {
                const url = '/api/explanatory-note/get-notes';
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(note) // массив будет направлен на kotlin
                });
                if (response.ok) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : null;
                } else {
                    console.error('Ошибка получения данных:', response.id);
                    this.makeToast('Предупреждение', 'Ошибка получения данных');
                }
            } catch (error) {
                console.error('Ошибка получения записей:', error);
            }
            return null
        },
        async getNote2(year, forecastId, prg) {

            try {

                const params = new URLSearchParams({
                    abp: this.curAbp.abp,
                    prg: prg,
                    gu: this.curGu.gu,
                    budget_type_id: this.curBudgetType.budget,
                    cur_year: this.curYear.year,
                    year: year,
                    region: this.curRegion.region,
                    budget_variant_id: this.curBudgetVariant.variant,
                    gkkp: this.curGkkp?.gkkp,
                    is_gkkp: this.isGkkp,
                    forecast_id: forecastId
                });

                const url = `/api/explanatory-note/indicator?${params.toString()}`;
                const response = await fetch(url);

                if (response.ok) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : null;

                } else {
                    this.makeToast('Предупреждение', 'Ошибка получения данных');
                    return null;
                }
            } catch (error) {
                console.error('Ошибка при выполнении запроса:', error);
                makeToast(this, 'danger', 'Ошибка загрузки "Целевых индикаторов"', error.toString());
                this.loading = false;
                return null;
            }
        },

        async downloadInstruction() {
            try {
                const response = await axios.post('/api-py/get-info/36', null, {
                    responseType: 'blob'
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Инструкция Пояснительная записка.pdf');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.makeToast('Ошибка', 'Не удалось скачать инструкцию');
            }
        },

        async reportGu() {
            this.progress = 0;
            // Пример: увеличиваем прогресс в процессе загрузки
            const interval = setInterval(() => {
                if (this.progress < 90) {
                    this.progress += 10;
                } else {
                    clearInterval(interval);
                }
            }, 500);

            const list1 = [];
            const list2 = [];
            const list3 = [];

            for (const prg of this.programList) {

                const note = {
                    curYear: this.curYear.year,
                    region: this.curRegion.region,
                    budgetTypeId: this.curBudgetType.budget,
                    budgetVariantId: this.curBudgetVariant.variant,
                    abp: this.curAbp.abp,
                    gu: this.curGu.gu,
                    gkkp: this.isGkkp ? this.curGkkp.gkkp : null,
                    prg: prg.prg,
                    id: null,
                    ppr: null,
                    year: this.curYear.year,
                    userId: this.userId,
                    nameKk: "",
                    nameRu: "",
                    nameEn: "",
                    titleIndicator: null,
                    titleSorting: null,
                    updateDate: null,
                }
                const response = await this.getNote(note)
                response.forEach((d) => {
                    list1.push({
                        id: d.id,
                        abp: d.abp,
                        prg: d.prg,
                        ppr: d.ppr,
                        gu: d.gu,
                        dataTypeId: d.budgetTypeId,
                        year: d.year,
                        curYear: d.curYear,
                        region: d.region,
                        variant: d.budgetVariantId,
                        nameKk: d.nameKk,
                        nameRu: d.nameRu,
                        titleIndicator: d.titleIndicator,
                        titleSorting: d.titleSorting,
                        userId: d.userId
                    });
                });

                const url = '/api/explanatory-note/budget-request-note/forecast/' +
                    this.curAbp.abp + '/' +
                    prg.prg + '/' +
                    this.curYear.year;

                const responseGoal = await fetch(url).then(response => response.json());

                for (const indicator of responseGoal.indicatorList) {
                    const forecastId = indicator.forecastId
                    for (const year of this.curYear.periods) {
                        const foundItem = await this.getNote2(year, forecastId, prg.prg)
                        if (foundItem) {

                            const goalItem = responseGoal.goalList.find(it =>
                                it.programId === foundItem.programId);
                            const indicatorItem = responseGoal.indicatorList.find(it =>
                                it.goalId === goalItem.id &&
                                it.programId === foundItem.programId);
                            const programItem = responseGoal.programList.find(it =>
                                it.forecastId === foundItem.forecastId)
                            list2.push({
                                programId: programItem.id,
                                programCode: programItem.code,
                                programEn: programItem.nameEn,
                                programKk: programItem.nameKk,
                                programRu: programItem.nameRu,
                                goalId: goalItem.id,
                                goalCode: goalItem.code,
                                goalEn: goalItem.nameEn,
                                goalKk: goalItem.nameKk,
                                goalRu: goalItem.nameRu,
                                indicatorId: indicatorItem.id,
                                indicatorCode: indicatorItem.code,
                                indicatorEn: indicatorItem.nameEn,
                                indicatorKk: indicatorItem.nameKk,
                                indicatorRu: indicatorItem.nameRu,
                                noteKk: foundItem ? foundItem.nameKk : "",
                                noteRu: foundItem ? foundItem.nameRu : "",
                                forecastId: foundItem.forecastId,
                                prg: prg.prg,
                                year: year
                            });
                        }

                    }
                }

                for (const year of this.curYear.periods) {

                    const params = new URLSearchParams({
                        year: year,
                        abp: this.curAbp.abp,
                        prg: prg.prg,
                        gu: this.curGu.gu,
                        variant: this.curBudgetVariant.variant,
                        bin: this.curGkkp?.gkkp,
                        is_gkkp: this.isGkkp,
                    });

                    const url = `/api/explanatory-note/get_ppr?${params.toString()}`;
                    let responseExpenses = await fetch(url);
                    responseExpenses = await responseExpenses.json();

                    responseExpenses.forEach((re) => {
                        const foundItem = response.find(it =>
                            it.abp === re.abp &&
                            it.ppr === re.ppr &&
                            it.prg === re.prg &&
                            it.year === year &&
                            it.titleIndicator.trim() === "ppr"
                        );
                        list3.push({
                            year: year,
                            abp: re.abp,
                            gu: re.gu,
                            nameKk: re.name_kk,
                            nameRu: re.name_ru,
                            ppr: re.ppr,
                            prg: re.prg,
                            value: re.value,
                            noteRu: foundItem ? foundItem.nameRu : "",
                            noteKk: foundItem ? foundItem.nameKk : ""
                        });
                    });
                }
            }

            try {


                const guNameKk = this.isGkkp
                    ? (this.curGkkp?.nameKk ?? this.curGkkp?.nameRu)
                    : this.curGu.nameKk;
                const guNameRu = this.isGkkp ? this.curGkkp?.nameRu : this.curGu.nameRu;

                const langCode = this.$i18n.locale;
                const title = {
                    variant: this.curBudgetVariant.variant,
                    programList: this.programList,
                    guNameKk: guNameKk,
                    guNameRu: guNameRu,
                    programKk: this.curBudgetType.nameKk,
                    programRu: this.curBudgetType.nameRu,
                    programNameKk: this.curBudgetVariant.nameKk,
                    programNameRu: this.curBudgetVariant.nameRu,
                    yearPeriod: this.curYear.periods,
                    year: this.curYear.year,
                    abp: this.curAbp.abp,
                    region: this.curRegion.region,
                    langCode: langCode
                }

                const params = {
                    data1: list1,
                    data2: list2,
                    data3: list3,
                    title: title
                };

                if (params) {
                    const axiosResponse = await axios.post('/api/word/write-gu', params, {
                        responseType: 'blob',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });

                    const url = window.URL.createObjectURL(new Blob([axiosResponse.data]));
                    const link = document.createElement('a');

                    link.href = url;

                    const docName = langCode === "ru" ? "ПЗ" : "ТЖ";
                    const guGkkpTitle = this.isGkkp ? this.curGkkp?.gkkp : this.curGu.gu
                    link.setAttribute('download', `${docName}_${guGkkpTitle}.docx`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.progress = 100;

                }
            } catch (error) {
                this.progress = 0;
                makeToast(this, 'danger', 'Ошибка загрузки Описаний на казахском и русском языках', error.toString());
            }

        },

        async reportAbp() {
            this.progress = 0;
            const interval = setInterval(() => {
                if (this.progress < 90) {
                    this.progress += 10;
                } else {
                    clearInterval(interval);
                }
            }, 500);

            try {
                // Собираем данные
                const total = [];
                const list1 = [];
                const list2 = [];
                const list3 = [];

                // Ваш существующий код сбора данных
                for (const gu of this.guFilter) {
                    const params = new URLSearchParams({
                        cur_year: this.curYear.year,
                        user_id: this.userId,
                        region: this.curRegion.region,
                        budget_type: this.curBudgetType.budget,
                        budget_variant: this.curBudgetVariant.variant,
                        abp: this.curAbp.abp,
                        gu: gu.gu,
                        is_gkkp: this.isGkkp,
                        gkkp: this.curGkkp?.gkkp,
                    });

                    const url = `/api/explanatory-note/total?${params.toString()}`;

                    const result = await fetch(url).then(response => response.json());

                    // Обработка результата
                    for (const funGr of result) {
                        for (const abp of funGr.child) {
                            for (const gu of abp.child) {
                                total.push({
                                    gu: this.curGu.gu,
                                    code: gu.guOrGkkp,
                                    nameRu: gu.nameRu,
                                    nameKk: gu.nameKk,
                                    prgList: gu.child?.map(prg => ({  // Добавляем prgList
                                        prg: prg.prg,
                                        nameRu: prg.nameRu,
                                        nameKk: prg.nameKk
                                    })) || []  // Запасной вариант на случай отсутствия child
                                });
                            }
                        }
                    }
                }

                // Собираем дополнительные данные (ваш существующий код)
                // ... list1, list2, list3 заполняются как раньше ...
                for (const gu of total) {
                    if (!gu.prgList) continue;
                    for (const prg of gu.prgList) {
                        const note = {
                            curYear: this.curYear.year,
                            region: this.curRegion.region,
                            budgetTypeId: this.curBudgetType.budget,
                            budgetVariantId: this.curBudgetVariant.variant,
                            abp: this.curAbp.abp,
                            gu: gu.code,
                            gkkp: this.isGkkp ? this.curGkkp.gkkp : null,
                            prg: prg.prg,
                            id: null,
                            ppr: null,
                            year: this.curYear.year,
                            userId: this.userId,
                            nameKk: "",
                            nameRu: "",
                            nameEn: "",
                            titleIndicator: null,
                            titleSorting: null,
                            updateDate: null,
                        }
                        const response = await this.getNote(note)
                        response.forEach((d) => {
                            list1.push({
                                id: d.id,
                                abp: d.abp,
                                prg: d.prg,
                                ppr: d.ppr,
                                gu: d.gu,
                                dataTypeId: d.budgetTypeId,
                                year: d.year,
                                curYear: d.curYear,
                                region: d.region,
                                variant: d.budgetVariantId,
                                nameKk: d.nameKk,
                                nameRu: d.nameRu,
                                titleIndicator: d.titleIndicator,
                                titleSorting: d.titleSorting,
                                userId: d.userId
                            });
                        });
                        const url = '/api/explanatory-note/budget-request-note/forecast/' +
                            this.curAbp.abp + '/' +
                            prg.prg + '/' +
                            this.curYear.year;
                        const responseGoal = await fetch(url).then(response => response.json());


                        for (const indicator of responseGoal.indicatorList) {
                            const forecastId = indicator.forecastId
                            for (const year of this.curYear.periods) {
                                const foundItem = await this.getNote2(year, forecastId, prg.prg)
                                if (foundItem) {

                                    const goalItem = responseGoal.goalList.find(it =>
                                        it.programId === foundItem.programId);
                                    const indicatorItem = responseGoal.indicatorList.find(it =>
                                        it.goalId === goalItem.id &&
                                        it.programId === foundItem.programId);
                                    const programItem = responseGoal.programList.find(it =>
                                        it.forecastId === foundItem.forecastId)
                                    list2.push({
                                        programId: programItem.id,
                                        programCode: programItem.code,
                                        programEn: programItem.nameEn,
                                        programKk: programItem.nameKk,
                                        programRu: programItem.nameRu,
                                        goalId: goalItem.id,
                                        goalCode: goalItem.code,
                                        goalEn: goalItem.nameEn,
                                        goalKk: goalItem.nameKk,
                                        goalRu: goalItem.nameRu,
                                        indicatorId: indicatorItem.id,
                                        indicatorCode: indicatorItem.code,
                                        indicatorEn: indicatorItem.nameEn,
                                        indicatorKk: indicatorItem.nameKk,
                                        indicatorRu: indicatorItem.nameRu,
                                        noteKk: foundItem ? foundItem.nameKk : "",
                                        noteRu: foundItem ? foundItem.nameRu : "",
                                        forecastId: foundItem.forecastId,
                                        prg: prg.prg,
                                        year: year
                                    });
                                }

                            }
                        }

                        for (const year of this.curYear.periods) {

                            const params = new URLSearchParams({
                                year: year,
                                abp: this.curAbp.abp,
                                prg: prg.prg,
                                gu: gu.code,
                                variant: this.curBudgetVariant.variant,
                                bin: this.curGkkp?.gkkp,
                                is_gkkp: this.isGkkp,
                            });

                            const url = `/api/explanatory-note/get_ppr?${params.toString()}`;

                            let responseExpenses = await fetch(url);
                            responseExpenses = await responseExpenses.json();

                            responseExpenses.forEach((re) => {
                                const foundItem = response.find(it =>
                                    it.abp === re.abp &&
                                    it.ppr === re.ppr &&
                                    it.prg === re.prg &&
                                    it.year === year &&
                                    it.titleIndicator.trim() === "ppr"
                                );
                                list3.push({
                                    year: year,
                                    abp: re.abp,
                                    gu: re.gu,
                                    nameKk: re.name_kk,
                                    nameRu: re.name_ru,
                                    ppr: re.ppr,
                                    prg: re.prg,
                                    value: re.value,
                                    noteRu: foundItem ? foundItem.nameRu : "",
                                    noteKk: foundItem ? foundItem.nameKk : ""
                                });
                            });
                        }

                    }
                }
                // Подготавливаем данные для отправки на сервер
                const requestData = {
                    gus: total,
                    langCode: this.$i18n.locale,
                    commonData: {
                        data1: list1,
                        data2: list2,
                        data3: list3,
                        programList: this.programList,
                        variant: this.curBudgetVariant.variant,
                        programKk: this.curBudgetType.nameKk,
                        programRu: this.curBudgetType.nameRu,
                        programNameKk: this.curBudgetVariant.nameKk,
                        programNameRu: this.curBudgetVariant.nameRu,
                        yearPeriod: this.curYear.periods,
                        year: this.curYear.year,
                        abp: this.curAbp.abp,
                        region: this.curRegion.region
                    }
                };

                // Отправляем запрос на создание ZIP-архива
                const response = await axios.post('/api/word/write-zip', requestData, {
                    responseType: 'blob'
                });

                // Скачиваем архив
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.curAbp.abp}_${this.curYear.year}.zip`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.progress = 100;

            } catch (error) {
                this.progress = 0;
                makeToast(this, 'danger', 'Ошибка создания архива', error.toString());
            }
        }, // сообщение с ошибкой

        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            const refItem = this.$refs[refName];
            setTimeout(() => refItem.$el.focus(), 100);
        },

        collapseAllFunc() {
            for (let i = 0; i < this.collapseArr.length; i++) {
                this.collapseArr[i] = this.collapse;
            }
            this.collapseArr.push(false);
            this.collapseArr.splice(this.collapseArr.length - 1, 1);
            // -------------------------------------------------------------------//
            for (let i = 0; i < this.collapseArrSec.length; i++) {
                this.collapseArrSec[i] = this.collapse;
            }
            this.collapseArrSec.push(false);
            this.collapseArrSec.splice(this.collapseArrSec.length - 1, 1);
            // -------------------------------------------------------------------//
            for (let i = 0; i < this.collapseArrThird.length; i++) {
                this.collapseArrThird[i] = this.collapse;
            }
            this.collapseArrThird.push(false);
            this.collapseArrThird.splice(this.collapseArrThird.length - 1, 1);
        },
        collapseItems(functItemIndex) {  // ---------Раскрытие первого уровня при нажатии на стрелку вниз
            const rowIndex = functItemIndex;
            this.collapseArr[rowIndex] = !this.collapseArr[rowIndex];
            this.collapseArr.push(false);
            this.collapseArr.splice(this.collapseArr.length - 1, 1);
        },
        collapseItemsSec(functItemIndex) {  // ---------Раскрытие второго уровня при нажатии на стрелку вниз
            const rowIndex = functItemIndex;
            this.collapseArrSec[rowIndex] = !this.collapseArrSec[rowIndex];
            this.collapseArrSec.push(false);
            this.collapseArrSec.splice(this.collapseArrSec.length - 1, 1);
        },
        collapseItemsThird(guItemIndex) {  // ---------Раскрытие четвертого уровня при нажатии на стрелку вниз
            const rowIndex = guItemIndex;
            this.collapseArrThird[rowIndex] = !this.collapseArrThird[rowIndex];
            this.collapseArrThird.push(false);
            this.collapseArrThird.splice(this.collapseArrThird.length - 1, 1);
        },

        makeToast(title, toastBody) {
            this.$bvToast.toast(toastBody, {
                title: title,
                autoHideDelay: 5000,
                appendToast: true
            });
        }

    }
}
</script>

<style lang="scss">

#report-first {
    text-transform: none;
}

.exp-textarea-style {
    position: relative;
    border: 1px solid #BCD2E0;
    border-radius: 5px;
    background-color: #EEF1F8;
    padding: 5px 10px;
    height: 90px;
    font-size: 14px;
    font-weight: 500;

    .tas-action {
        position: absolute;
        color: #2196F3;
        top: 5px;
        right: 10px;
        font-size: 20px;
        cursor: pointer;

        &:hover {
            color: #1b7cc9;
        }
    }

}

.text-area-block-empty {
    border: 1px solid #EE0505;
    border-radius: 5px;
}

.text-area-block {
    border: 1px solid #BCD2E0;
    border-radius: 5px;
}

.exp-note-table {
    tbody {
        td {
            padding: 10px !important;
        }
    }
}

.enf-modal {
    .modal-title {
        font-size: 14px;
        font-weight: 700;
        color: #1C2A3E;
        border-bottom: none;
    }


    legend {
        margin-bottom: 10px;
    }

    .form-control {
        min-height: 65px;
        border: 1px solid #BCD2E0;
        border-radius: 5px;
        background-color: #fff;
        font-size: 14px;
        font-weight: 500;
    }
}

.explanatory-note {
    .enf-form-group {
        position: relative;

        .icon-pencil-edit,
        .icon-eye-open {
            position: absolute;
            right: 15px;
            color: #2196F3;
            cursor: pointer;
        }

        .icon-eye-open {
            top: 9px;
        }

        .icon-pencil-edit {
            top: 12px;
        }
    }

    .enf-top-info {
        position: absolute;
        top: 40px;
        right: 10px;
        z-index: 1005;

        .duplicate-radio {
            margin-top: 6px;
            display: flex;
            align-content: center;

            .custom-radio {
                text-transform: uppercase;
            }

            .enf-label {
                color: #1C2A3E;
                font-size: 14px;
                margin-top: 6px;
                font-weight: 700;
                margin-right: 20px;
            }
        }
    }

    .add-program {
        padding: 15px 20px;
        display: inline-flex;
        font-size: 14px;
        align-content: center;
        color: #2196F3 !important;
        cursor: pointer;

        i {
            margin-right: 15px;
            font-size: 20px;
        }

        b {
            text-decoration: underline;
        }
    }

    .td-link:hover {
        color: #2196F3 !important;
        cursor: pointer;
    }

    .more {
        .text-danger {
            button {
                color: #dc3545 !important;
            }
        }
    }

    .explanatory-note-form {
        .enf-title {
            padding: 10px 20px;
            background-color: #fff;
            font-size: 14px;
            font-weight: 700;
            display: flex;
            align-content: center;
            justify-content: flex-start;

            i {
                color: #2196F3;
                font-size: 17px;
                margin-left: 10px;
                cursor: pointer;
            }
        }

        .enf-row {
            margin: 0;
            padding: 10px;
            border-top: 1px solid #D3DBE3;
            border-bottom: 1px solid #D3DBE3;
        }

        .form-group {
            margin: 0;
        }

        .form-row {
            margin: 0;
            align-items: flex-start;
        }
    }

    .table-container {
        .add-indicator {
            .icon-plus-circle {
                font-size: 20px;
                color: #2196F3;
            }

            span {
                color: #2196F3;
                display: inline-flex;
                align-content: center;
                cursor: pointer;

                b {
                    text-decoration: underline;
                }

                i {
                    margin-right: 10px;
                }
            }
        }

        .enf-row {
            margin: 0;
            padding: 0;
            border-top: none;
            border-bottom: none;
        }

    }


}
</style>